import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDealContext } from "@/contexts/DealContext";
import { capitalizeFirstLetter } from "@/components/review/LoanSetupStep";

const DealSummaryPage: React.FC = () => {
  const navigate = useNavigate();
  const { deal } = useDealContext();
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Deal Summary: {deal.name}
        </Typography>
        {deal.loans.map((loan) => (
          <Paper elevation={2} key={loan.id} sx={{ mb: 2, p: 2 }}>
            <Typography variant="body1">Loan Name: {loan.name}</Typography>
            <Typography variant="body1">
              Loan Type: {capitalizeFirstLetter(loan.type?.replaceAll("_", " ") || "")}
            </Typography>
            <Typography variant="body1">
              Amount:{" "}
              {loan.amount
                ? `${Number(loan.amount.amount.value).toLocaleString("fi-FI", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    style: "currency",
                    currency: loan.amount?.currency.value,
                    currencyDisplay: "code",
                  })}`
                : "N/A"}
            </Typography>
          </Paper>
        ))}
        <Box display="flex" justifyContent="space-between" mt={3}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default DealSummaryPage;
